import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const TrainingDocumentVerificationRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--training--user-records']}>
    <Route index element={<Index />} />
  </SubRouter>
))
